import { ccEdgesAtom, ccNodesAtom } from "components/CC/atoms/diagramAtom";
import { diagramLogAtom } from "components/CC/atoms/diagramLogAtom";
import { useCallback } from "react";
import { useRecoilValue } from "recoil";

import {
    buildParameterPickerCategories,
    BuildParameterPickerCategoriesOptions,
} from "./buildParameterPickerCategories";

interface UseBuildParameterPickerCategoriesOptions {
    t: (key: string, options?: Record<string, unknown>) => string;
    formFields?: App.Data.FormFieldData[];
    customFields?: BuildParameterPickerCategoriesOptions["customFields"];
    currentNodeId?: string;
    defaultSetTitle?: string;
}

type BuildCategoriesInput = Omit<
    BuildParameterPickerCategoriesOptions,
    "t" | "formFields" | "customFields" | "previousSteps"
>;

export const useBuildParameterPickerCategories = ({
    t,
    formFields,
    customFields,
    currentNodeId,
    defaultSetTitle,
}: UseBuildParameterPickerCategoriesOptions) => {
    const nodes = useRecoilValue(ccNodesAtom);
    const edges = useRecoilValue(ccEdgesAtom);
    const httpStepAggregates = useRecoilValue(diagramLogAtom);
    const resolvedDefaultSetTitle = defaultSetTitle ?? t("nodes.set.title");

    return useCallback(
        ({ allowedCategories, rows }: BuildCategoriesInput) =>
            buildParameterPickerCategories({
                t,
                allowedCategories,
                formFields,
                customFields,
                previousSteps: currentNodeId
                    ? {
                          nodes,
                          edges,
                          currentNodeId,
                          defaultSetTitle: resolvedDefaultSetTitle,
                          httpStepAggregates,
                      }
                    : undefined,
                rows,
            }),
        [t, formFields, customFields, currentNodeId, resolvedDefaultSetTitle, nodes, edges, httpStepAggregates]
    );
};
